<div class="client-sel-main" fxLayout="row">
  <div class="container">
    <div class="sub_container">
      <div class="row main_row">
        <div class="col-md-6 col-sm-12 col-xs-12 coll">
          <a routerLink="/process-run/anc" style="text-decoration:none">
          <mat-card>

            <div class="logo_div" fxLayout="row" fxLayoutAlign="center center">

              <!--<img mat-card-image src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/1200px-Google_%22G%22_Logo.svg.png" alt="Photo of a Shiba Inu" />-->
              <h2 class="titles">ANC</h2>
            </div>

          </mat-card>
            </a>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12 coll">
          <a routerLink="/process-run/auc" style="text-decoration:none">

            <mat-card>

              <div class="logo_div" fxLayout="row" fxLayoutAlign="center center">

                <h2 class="titles">AUC</h2>

              </div>

            </mat-card>
            </a>
        </div>
      </div>
    </div>
  </div>
</div>

